export default __webpack_public_path__ + "static/media/tropicana-middle.b9941d16.png";